<template>
  <div>
      <div class="right_wrapper">
        <AddProductHeader></AddProductHeader>
        <AddProductForm class="table_wrap no_footer pt-2"></AddProductForm>
      </div>
    <!-- Modal Starts -->
    <AddKeywordModal></AddKeywordModal>
    </div>
</template>

<script>
import AddProductHeader from '@/components/add-product/AddProductHeader'
import AddProductForm from '@/components/add-product/AddProductForm'
import AddKeywordModal from '@/components/add-product/AddKeywordModal'


export default {
    components: {
      AddProductHeader,
      AddProductForm,
      AddKeywordModal,
    }

}
</script>

<style lang="scss">

</style>
